import { scopeDataOperations } from '@ardoq/scope-data';
import { toIdSet } from '@ardoq/core';
import type { WorkspaceAndModelLookup } from '@ardoq/data-model';
import type {
  APIComponentAttributes,
  APIFieldAttributes,
  APIReferenceAttributes,
  APIModelAttributes,
  ArdoqId,
  APIScopeData,
} from '@ardoq/api-types';

export const toScopeData = (
  workspaceIds: ArdoqId[],
  workspaceAndModel: WorkspaceAndModelLookup,
  fields: APIFieldAttributes[],
  components: APIComponentAttributes[],
  references: APIReferenceAttributes[]
): APIScopeData => {
  const allComponents: APIComponentAttributes[] = [];
  const allReferences: APIReferenceAttributes[] = [];
  const allModels: APIModelAttributes[] = [];

  workspaceIds.forEach(workspaceId => {
    const result = scopeDataOperations.getWorkspaceAndModel(
      workspaceAndModel,
      workspaceId
    );
    if (result) {
      const { model } = result;
      const workspaceComponents = components.filter(
        component => component.rootWorkspace === workspaceId
      );
      const workspaceReferences = references.filter(
        reference => reference.rootWorkspace === workspaceId
      );

      allComponents.push(...workspaceComponents);
      allReferences.push(...workspaceReferences);
      allModels.push(model);
    }
  });
  const modelIds = toIdSet(allModels);

  const allFields = fields.filter(field => modelIds.has(field.model));

  const contextWorkspaces = Object.values(
    workspaceAndModel.workspacesById
  ).filter(workspace => workspaceIds.includes(workspace._id));

  return {
    components: allComponents,
    references: allReferences,
    models: allModels,
    workspaces: contextWorkspaces,
    fields: allFields,
    attachments: [],
    tags: [],
    scopeComponents: allComponents.map(c => c._id),
    dateRangeFieldMap: new Map(),
    users: [],
  };
};
